import { ViewManager } from "./view-manager";
import { views } from "./views";


export
{
    ViewManager,
    views,
};
